import React, { useEffect, useRef, useState } from "react";
import { exportProductToPdf } from "utils/export/ExportProduct";
import PrintButton from "components/Button/PrintButton";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DownloadPageSize, DropdownStatusList, FormTypeAdd, FormTypeEdit, PageSize, StatusCodeActive } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import Dropdown from "components/Input/Dropdown";
import { GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "context/ModalContext";
import Select from 'react-select'
import { FilterCard, MainBodyCard, PagesTitle } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import { ProductService } from "services/ProductService/ProductService";
import { SystemService } from "services/SystemService/SystemService";
import { BrandService } from "services/BrandService/BrandService";
import GridEditButton from "components/Button/GridEditButton";
import GridDeleteButton from "components/Button/GridDeleteButton";
import AddButton from "components/Button/AddButton";
import DataTable from "components/DataTable";

export default function Product(){
    let navigate = useNavigate()
    
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchProductList, fetchDeleteProduct } = ProductService()
    const { fetchBrandList } = BrandService()
    const { fetchSystem } = SystemService()
    const firstLoad = useRef(true)

    const [productName, setProductName] = useState('')
    const [brandOptions, setBrandOptions] = useState('')
    const [brand, setBrand] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [tax, setTax] = useState('')
    const [productList, setProductList] = useState([])
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center",
        },
        {
            key: "brandName",
            header: "Brand"
        },
        {
            key: "productName",
            header: "Nama Item"
        },
        {
            key: "price",
            header: "Price",
            render: (row) => 'Rp ' + money(row.price),
        },
        {
            key: "discount",
            header: "Discount",
            render: (row) => row.discount + ' %',
        },
        {
            key: "tax",
            header: "Tax",
            render: (row) => tax + ' %',
        },
        {
            key: "nettPrice",
            header: "Final Price",
            render: (row) => 'Rp ' + money(row.nettPrice),
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.productId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.productId, row.status)} size="w-3" />
                </div>
                
            ),
        },
    ]

    // Button Event
    const addBtnClick = () => {
        navigate("/product/form?productId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/product/form?productId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = async (id, status) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            const res = await fetchDeleteProduct(id, status)
            if (!res) return 

            showSuccess({
                onSuccess: () => {
                    handlePageChange(pageIndex)
                }
            })
        }
        finally {
            hideLoading()
        }
    }

    // Function Grid
    const handlePageChange = async (newIndex) => {
        const res = await fetchProductList(productName, brand === null || brand === '' ? '' : brand.value, status, PageSize, newIndex)
        if (!res) return

        const totalData = res?.data?.totalData ?? 0;
        const total = Math.max(1, Math.ceil(totalData / PageSize))

        setProductList(res)
        setTotalPages(total)
        setPageIndex(newIndex)
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                if (firstLoad.current) {
                    let res = await fetchSystem('tax')
                    if (!res) return

                    setTax(res.data.systemValue)

                    res = await fetchBrandList('', '1', 1000, 0)
                    if (!res) return

                    let data = res?.data?.listData
                    let arr = [{ label: 'All', value: '' }]

                    data.map((data) => arr.push({ label: data.brandName, value: String(data.brandId)}))

                    setBrandOptions(arr)

                    firstLoad.current = false
                }
                                
                await handlePageChange(0)
            }
            finally {
                hideLoading()
            }
        }

        onLoad()        
    },[brand, productName, status])

    const exportPdfBtnClick = async () => {
        showLoading()

        try {
            const res = await fetchProductList(productName, brand === null || brand === '' ? '' : brand.value, status, DownloadPageSize, 0)
            if (!res) return

            exportProductToPdf(res?.data?.listData ?? [], { tax })
        }
        finally {
            hideLoading()
        }
    };

    return(
        <MainBodyCard>
            <PagesTitle title='Product' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-2">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Brand'>
                        <Select options={brandOptions} value={brand} onChange={(e) => { setBrand(e) }} placeholder='All' />
                    </FilterCard>

                    <FilterCard title='Nama Item'>
                        <input className="input" value={productName} onChange={(e) => { setProductName(e.target.value) }} />
                    </FilterCard>

                    <FilterCard title='Brand'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </FilterCard>
                    
                </div>
            </div>

            <div className="flex w-full justify-end gap-2 mt-4">
                <PrintButton
                    className="px-4 py-2 rounded-full border bg-white hover:bg-slate-100 whitespace-nowrap"
                    onClick={exportPdfBtnClick}
                >
                    Export PDF
                </PrintButton>
                <AddButton onClick={addBtnClick} text='Tambah Product' />
            </div>
           
            {/* WIDE SCREEN */}
            <div className="mt-5 hidden sm:block">
                <DataTable
                    columns={columns}
                    data={productList?.data?.listData ?? []}
                />
            </div>

            {/* MOBILE SCREEN */}
            <div className="mt-5 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm sm:hidden">
                { productList?.data?.listData?.length === 0 && (
                    <div className="text-center h-12">
                        <span>No Data Available</span> 
                    </div>
                )}
                { productList?.data?.listData?.map((data, i) => {
                    return(
                        <div className="my-2 row border p-2 rounded-lg hover:bg-slate-100 flex justify-between items-center" key={ i }>
                            <div className="flex flex-col">
                                <span>{data.brandName} {data.productName}</span>
                                <span>Rp {money(data.nettPrice)}</span>
                            </div>
                            <div className="flex gap-1">
                                <button className="bg-black p-2 rounded-lg gap-2 flex" onClick={() => editBtnClick(data.productId)}>
                                    <EditIcon className="w-3 fill-white" />
                                </button>
                                <button className={`bg-black p-2 rounded-lg flex gap-2`} onClick={() => deleteBtnClick(data.productId, data.status)}>
                                    {data.status === StatusCodeActive ? (<TrashIcon className="w-3 fill-white" />) : (<RevisionIcon className="w-4 fill-white" />)}
                                </button>
                            </div>
                        </div>
                    )
                })}
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </MainBodyCard>
    )
}